import { Tile } from '@/components/layout';
import { ComponentProps, FC } from 'react';
import { twMerge } from 'tailwind-merge';

type TileProps = ComponentProps<typeof Tile>;

export const UnifiedProfileTile: FC<TileProps> = ({ className, ...rest }) => (
  <Tile className={twMerge('p-6 border-secondary-border rounded-lg', className)} {...rest} />
);
